/**
 * Регионы ВОЗ для 194 государств-членов (ISO3 → регион).
 *
 * AFR — Африканский, AMR — Американский, SEAR — Юго-Восточная Азия,
 * EUR — Европейский, EMR — Восточное Средиземноморье, WPR — Западная часть
 * Тихого океана. Страны вне списка (не члены ВОЗ) в датасет не попадают.
 */
import type { WhoRegion } from './schema';

const AFR = [
  'DZA', 'AGO', 'BEN', 'BWA', 'BFA', 'BDI', 'CMR', 'CPV', 'CAF', 'TCD', 'COM', 'COG', 'CIV', 'COD',
  'GNQ', 'ERI', 'SWZ', 'ETH', 'GAB', 'GMB', 'GHA', 'GIN', 'GNB', 'KEN', 'LSO', 'LBR', 'MDG', 'MWI',
  'MLI', 'MRT', 'MUS', 'MOZ', 'NAM', 'NER', 'NGA', 'RWA', 'STP', 'SEN', 'SYC', 'SLE', 'ZAF', 'SSD',
  'TGO', 'UGA', 'TZA', 'ZMB', 'ZWE',
];

const AMR = [
  'ATG', 'ARG', 'BHS', 'BRB', 'BLZ', 'BOL', 'BRA', 'CAN', 'CHL', 'COL', 'CRI', 'CUB', 'DMA', 'DOM',
  'ECU', 'SLV', 'GRD', 'GTM', 'GUY', 'HTI', 'HND', 'JAM', 'MEX', 'NIC', 'PAN', 'PRY', 'PER', 'KNA',
  'LCA', 'VCT', 'SUR', 'TTO', 'USA', 'URY', 'VEN',
];

const SEAR = ['BGD', 'BTN', 'PRK', 'IND', 'IDN', 'MDV', 'MMR', 'NPL', 'LKA', 'THA', 'TLS'];

const EUR = [
  'ALB', 'AND', 'ARM', 'AUT', 'AZE', 'BLR', 'BEL', 'BIH', 'BGR', 'HRV', 'CYP', 'CZE', 'DNK', 'EST',
  'FIN', 'FRA', 'GEO', 'DEU', 'GRC', 'HUN', 'ISL', 'IRL', 'ISR', 'ITA', 'KAZ', 'KGZ', 'LVA', 'LTU',
  'LUX', 'MLT', 'MCO', 'MNE', 'NLD', 'MKD', 'NOR', 'POL', 'PRT', 'MDA', 'ROU', 'RUS', 'SMR', 'SRB',
  'SVK', 'SVN', 'ESP', 'SWE', 'CHE', 'TJK', 'TUR', 'TKM', 'UKR', 'GBR', 'UZB',
];

const EMR = [
  'AFG', 'BHR', 'DJI', 'EGY', 'IRN', 'IRQ', 'JOR', 'KWT', 'LBN', 'LBY', 'MAR', 'OMN', 'PAK', 'QAT',
  'SAU', 'SOM', 'SDN', 'SYR', 'TUN', 'ARE', 'YEM',
];

const WPR = [
  'AUS', 'BRN', 'KHM', 'CHN', 'COK', 'FJI', 'JPN', 'KIR', 'LAO', 'MYS', 'MHL', 'FSM', 'MNG', 'NRU',
  'NZL', 'NIU', 'PLW', 'PNG', 'PHL', 'KOR', 'WSM', 'SGP', 'SLB', 'TON', 'TUV', 'VUT', 'VNM',
];

function assign(target: Record<string, WhoRegion>, codes: string[], region: WhoRegion): void {
  for (const code of codes) {
    if (code in target) throw new Error(`Duplicate WHO member code: ${code}`);
    target[code] = region;
  }
}

function buildTable(): Record<string, WhoRegion> {
  const table: Record<string, WhoRegion> = {};
  assign(table, AFR, 'AFR');
  assign(table, AMR, 'AMR');
  assign(table, SEAR, 'SEAR');
  assign(table, EUR, 'EUR');
  assign(table, EMR, 'EMR');
  assign(table, WPR, 'WPR');
  return table;
}

export const WHO_REGION: Record<string, WhoRegion> = buildTable();
